module.exports = __webpack_public_path__ + "img/baokuan.03a1f08a.png";